/**
 * @Auther: Qsan
 * @Date：2018年10月28日 12:38
 * @Desc：工具库
 */
import allParams from "./params";
import { Message } from "element-ui";

function toQueryPair(key, value) {
  if (typeof value === "undefined") {
    return key;
  }
  return key + "=" + encodeURIComponent(value === null ? "" : String(value));
}

export function toQueryString(obj) {
  var ret = [];
  for (var key in obj) {
    key = encodeURIComponent(key);
    var values = obj[key];
    if (values && values.constructor === Array) {
      // 数组
      var queryValues = [];
      for (var i = 0, len = values.length, value; i < len; i++) {
        value = values[i];
        queryValues.push(toQueryPair(key, value));
      }
      ret = ret.concat(queryValues);
    } else {
      // 字符串
      ret.push(toQueryPair(key, values));
    }
  }
  return ret.join("&");
}

/**
 * 获取指定范围内的随机数
 * @param min
 * @param max
 * @returns {number}
 */
export function getRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * 截取路径
 * @param path
 * @returns { string }
 */
export function slicePath(path, number = 3) {
  return path
    .split("/")
    .slice(0, number + 1)
    .join("/");
}

/**
 * 防止Message重复弹出
 */
let messageInstance = null;
export function resetMessage(options) {
  if (messageInstance) {
    messageInstance.close(); // 关闭
  }
  messageInstance = Message(options);
}

["error"].forEach((type) => {
  resetMessage[type] = (options) => {
    if (typeof options === "string") {
      options = {
        message: options,
      };
    }
    options.type = type;
    return resetMessage(options);
  };
});

/**
 * 获取用户信息
 */
export function getUser() {
  return window.$QS.parse(window.$cookie.getCookie("userInfo")) || {};
}

/**
 * 通过参数码获取相应参数数组
 * @param code
 * @returns {*|Array}
 */
export function getParams(code) {
  return allParams[code] || [];
}

/**
 * 通过参数码、值获取相应指定值参数对象
 * @param code
 * @param value
 */
export function getParam(code, value) {
  let params = getParams(code);
  let param = {};

  for (let i = 0; i < params.length; i++) {
    if (params[i].value === value) {
      param = params[i];
      break;
    }
  }
  return param;
}

// 将登陆的jwt时间进行转换
export function getJwtTime(time) {
  return time / 1000 / 60 / 60 / 24;
}
// 获取当前时间
export function nowTime() {
  // 获取当前时间
  let now = new Date();
  let _month = now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
  let _day = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
  let _hour = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
  let _minute = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
  let _second = now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
  return now.getFullYear() + "-" + _month + "-" + _day + " " + _hour + ":" + _minute + ":" + _second;
}

// 获取当前日期
export function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

// 将时间格式化
export function getTime(time) {
  let d = new Date(parseInt(time) * 1000 + 8 * 3600 * 1000);
  return d
    .toJSON()
    .substr(0, 19)
    .replace("T", " ")
    .replace("+", "");
}

// 将图片进行base转换
export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// 判断get请求参数
export function filterParams(obj) {
  let _newPar = {};
  for (let key in obj) {
    // 如果对象属性的值不为空，就保存该属性（这里我做了限制，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
    if ((obj[key] == 0 || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, "") !== "") {
      // obj[key] == 0 判断值如果为0 并且去除值可能存在的空字符，如果最终不等于空字符则说明此值可以进行存储，如果为不成立则忽略此值
      // 记录属性
      _newPar[key] = obj[key];
    }
  }
  // 返回对象
  return _newPar;
}

// // 获取cookie
// export function getCookie (cname) {
//     let arr
//     let reg = new RegExp('(^| )' + cname + '=([^;]*)(;|$)')
//     if ((arr = document.cookie.match(reg))) return JSON.parse(unescape(arr[2]))
//     else return null
// }
//
// // 设置cookie
// export function setCookie (cname, cvalue, exdays, path) {
//     var vCk = cname + '=' + cvalue + ';'
//     if (exdays) {
//         var d = new Date()
//         d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
//         var expires = ' expires=' + d.toUTCString() + ';'
//         vCk += expires
//     }
//     if (path) {
//         vCk += 'path=' + path + ';domain=' + document.domain
//     }
//     document.cookie = vCk
// }
//
export function removeCookie(cname, path) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let delAttr = cname + "=v;expires=" + exp.toUTCString();
  if (path) {
    delAttr += ";path=" + path + ";domain=" + document.domain;
  }
  return (document.cookie = delAttr);
}

// 遍历2级别菜单 判断权限
export function getSecMeauList(listData, permissionlist) {
  for (let i = 0; i < listData.length; i++) {
    if (listData[i].children) {
      for (let k = 0; k < listData[i].children.length; k++) {
        listData[i].children[k].meta.second = false;
        // listData[i].children[k].meta.No = "";
      }
    }
  }
  console.log(listData, "getSecMeauList");
  // let index = 0;
  for (let i = 0; i < listData.length; i++) {
    if (listData[i].children) {
      for (let j = 0; j < permissionlist.length; j++) {
        for (let k = 0; k < listData[i].children.length; k++) {
          if (permissionlist[j].resourceName == listData[i].children[k].meta.title) {
            // console.log(
            //     listData[i].children[k].children,
            //     "children"
            // );
            // for (
            //     let index = 0;
            //     index < listData[i].children.length;
            //     index++
            // ) {
            //     listData[i].children[k].meta.No = index;
            // }
            // console.log(
            //     listData[i].children[k].meta.title,
            //     "===>",
            //     k,
            //     "k"
            // );

            // listData[i].children[k].meta.No = "";
            listData[i].children[k].meta.second = true;
          }
        }
      }
    }
  }

  // listData.forEach(res => {
  //     if (res.children) {
  //         permissionlist.forEach(element => {
  //             res.children.map(ele => {
  //                 if (element.resourceName == ele.meta.title) {
  //                     ele.meta.second = true;
  //                 }
  //                 return ele;
  //             });
  //         });
  //     }
  // });
  // treeData(listData);
  // sessionStorage.setItem("listdata", JSON.stringify(this.listData));
}

export function treeData(listData) {
  listData.forEach((item) => {
    if (item.children && item.path !== "/") {
      item.children.forEach((ele) => {
        console.log(ele, "二级");
        if (ele.children) {
          ele.children.forEach((k) => {
            console.log(k.meta);
            // console.log(k.meta.second, "second");
          });
        }
      });
    }
  });
}
/**
 * @desc 防抖函数
 * @param {需要防抖的函数} func
 * @param {延迟时间} wait
 * @param {是否立即执行} immediate
 */
export function debounce(func, wait, immediate) {
  let timeout;
  return function(...args) {
    let context = this;
    if (typeof wait == "function") {
      wait.apply(context, args);
      // wait();
    }

    if (timeout) clearTimeout(timeout);
    // 立即执行函数防抖
    if (immediate) {
      let callNow = !timeout;
      timeout = setTimeout(function() {
        timeout = null;
      }, wait);

      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(function() {
        func.apply(context, args);
        clearTimeout(timeout);
      }, wait);
    }
  };
}
/**
 * @desc 节流函数
 * @param {需要防抖的函数} fn
 * @param {延迟时间} delay
 */
export function throttle(fn, delay) {
  var lastTime;
  var timer;
  var delay = delay || 200;
  return function() {
    var args = arguments;
    // 记录当前函数触发的时间
    var nowTime = Date.now();
    if (lastTime && nowTime - lastTime < delay) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        // 记录上一次函数触发的时间
        lastTime = nowTime;
        // 修正this指向问题
        fn.apply(this, args);
      }, delay);
    } else {
      lastTime = nowTime;
      fn.apply(this, args);
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/utils.js